// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/PROGRESS PERSONAL USE.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Modern Reset */

* {
  /* outline: 3px solid orange; */
}

/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin */
* {
  margin: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* Typography / Visuals */
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

/* Custom Properties */

:root {
  /* Primary Colors */
  --bg-primary: hsl(0, 1%, 33%);
  --bg-dark-light: #4a4a4a;
  --bg-dark-medium: #3b3b3b;
  --bg-dark-heavy: #2e2e2e;
  --bg-board: rgba(14, 32, 65);
  --bg-sunk-ship: #480c0c;

  /* Text Colors */
  --text-primary: #e6e6e6;
  --text-light: #fff;
  --text-logo: #6b6a6a;

  /* Border & Accent Colors */
  --border-light: hsl(0, 0%, 68%);
  --border-dark: #1f1f1f;
  --accent-blue-1: #00d2ff;
  --accent-blue-2: #3a47d5;
  --accent-purple: purple;
  --accent-red: red;

  /* Gradient Colors */
  --gradient-shine: #232526;
  --gradient-bright: #414345;
  --gradient-accent-1: #777;
  --gradient-accent-2: #222;

  /* Logo Shadow Colors */
  --shadow-1: #fff;
  --shadow-2: #2e2e2e;
  --shadow-3: #2c2c2c;
  --shadow-4: #2a2a2a;
  --shadow-5: #282828;
  --shadow-6: #262626;
  --shadow-7: #242424;
  --shadow-8: #222;
  --shadow-9: #202020;
  --shadow-10: #1e1e1e;
  --shadow-11: #1c1c1c;
  --shadow-12: #1a1a1a;
  --shadow-13: #181818;
  --shadow-14: #161616;
  --shadow-15: #141414;
  --shadow-16: #121212;

  /* Transparency Colors */
  --rgba-white-heavy: rgba(255, 255, 255, 0.2);
  --rgba-white-light: rgba(255, 255, 255, 0.18);
  --rgba-white-lighter: rgba(255, 255, 255, 0.08);
  --rgba-black-medium: rgba(0, 0, 0, 0.2);
  --rgba-black-heavy: rgba(0, 0, 0, 0.6);
  --rgba-black-darkest: rgba(0, 0, 0, 0.9);
}

html {
  height: 100%;
}

html,
body {
  min-height: 100%;
  background: radial-gradient(
    circle at center,
    #3f3f3f 0%,
    #2f2f2f 40%,
    #1e1e1e 100%
  );
}

body {
  /* Grid / Flex Layout */
  display: grid;
  place-items: center;
  grid-template-rows: max-content max-content max-content max-content;
  row-gap: 1.75rem;

  /* Box Model */
  padding-bottom: 28px;

  /* Typography / Visuals */
  font-family: 'Progress', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.5;

  -webkit-font-smoothing: antialiased;

  /* Miscellaneous / Interactions */
  box-shadow: inset 0 0 7.5rem rgba(0, 0, 0, 0.4);
}

/* Text / Font */

p {
  color: var(--text-primary);
  font-size: 1.25rem;
}

@font-face {
  font-family: Progress;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Logo / Info Panel */

.logo-text {
  /* Box Model */
  margin: 0.625rem;

  /* Typography / Visuals */
  font-size: 5rem;
  font-weight: 500;
  letter-spacing: 0.125rem;
  color: var(--text-logo);

  /* Miscellaneous / Interactions */
  text-shadow:
    0 -1px 0 var(--shadow-1),
    0 1px 0 var(--shadow-2),
    0 2px 0 var(--shadow-3),
    0 3px 0 var(--shadow-4),
    0 4px 0 var(--shadow-5),
    0 5px 0 var(--shadow-6),
    0 6px 0 var(--shadow-7),
    0 7px 0 var(--shadow-8),
    0 8px 0 var(--shadow-9),
    0 9px 0 var(--shadow-10),
    0 10px 0 var(--shadow-11),
    0 11px 0 var(--shadow-12),
    0 12px 0 var(--shadow-13),
    0 13px 0 var(--shadow-14),
    0 14px 0 var(--shadow-15),
    0 15px 0 var(--shadow-16),
    0 1.375rem 1.875rem var(--rgba-black-darkest);
}

.info-container {
  /* Box Model */
  position: relative;
  min-width: 28%;
  padding: 0.5rem 2rem;
  border-radius: 0.1875rem;
  border: 1px solid var(--border-dark);

  /* Typography / Visuals */
  text-align: center;
  font-size: 0.875rem;
  color: var(--text-primary);
  letter-spacing: 0.0625rem;
  background:
    radial-gradient(
      ellipse at center,
      var(--rgba-white-light) 0%,
      var(--rgba-white-lighter) 40%,
      var(--rgba-black-medium) 100%
    ),
    linear-gradient(
      to bottom,
      var(--bg-dark-light) 0%,
      var(--bg-dark-medium) 50%,
      var(--bg-dark-heavy) 100%
    );

  /* Miscellaneous / Interactions */
  box-shadow:
    inset 0 1px 0 var(--rgba-white-heavy),
    inset 0 -1px 0 var(--rgba-black-heavy),
    0 2px 4px var(--rgba-black-heavy);
}

.info-container::before,
.info-container::after {
  /* Box Model */
  content: '';
  position: absolute;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);

  /* Typography / Visuals */
  background: radial-gradient(
    circle,
    var(--gradient-accent-1) 0%,
    var(--gradient-accent-2) 70%
  );
}

.info-container::before {
  left: 0.75rem;
}

.info-container::after {
  right: 0.75rem;
}

/* Game Boards */

.boards-container {
  display: flex;
  gap: 3rem;
}

.outter-board-wrap {
  /* Box Model */
  position: relative;
  padding: 0.5625rem;
  border-radius: 0.25rem;

  /* Miscellaneous / Interactions */
  transition: background-position 0.3s ease;
}

.outter-board-wrap:hover {
  background-position: center right;
}

.inner-board-wrap {
  /* Box Model */
  position: relative;
  padding: 0.25rem;

  /* Typography / Visuals */
  background: linear-gradient(
    to right,
    var(--accent-blue-1) 0%,
    var(--accent-blue-2) 60%
  );
}

.inner-board-wrap.enemy {
  /* Visuals */
  background: linear-gradient(
    to right,
    var(--accent-purple),
    var(--accent-red)
  );
}

.human-section,
.cpu-section {
  display: grid;
  place-items: center;
  row-gap: 0.75rem;
}

.human-board,
.cpu-board {
  display: grid;

  /* Box Model */
  width: 348px;
  height: 348px;

  user-select: none;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none;
}

.row {
  display: flex;
  flex-direction: row;
  flex: 1;
}

/* Cells */

.cell {
  /* Grid / Flex Layout */
  display: flex;
  flex: 1;

  /* Box Model */
  position: relative;
  border-right: 2px solid var(--border-light);
  border-bottom: 2px solid var(--border-light);

  /* Typography / Visuals */
  background-color: var(--bg-board);
}

.row .cell:nth-child(10) {
  border-right: 0px;
}

.row:nth-child(10) .cell {
  border-bottom: 0px;
}

.cpu-board .cell:hover {
  cursor: crosshair;
}

.human-board .cell:hover {
  cursor: not-allowed;
}

.cell > img {
  /* Box Model */
  position: absolute;
  width: 60%;

  /* Miscellaneous / Interactions */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.cell.ship:not(.sunk) {
  background-image: linear-gradient(
    to right,
    var(--gradient-shine) 0%,
    var(--gradient-bright) 51%,
    var(--gradient-shine) 100%
  );
  background-size: 200% auto;
}

.cell.ship.sunk {
  background-color: var(--bg-sunk-ship);
}

/* Buttons */

.buttons {
  /* Grid / Flex Layout */
  display: grid;
  place-items: center;
  grid-template-rows: max-content max-content;
  row-gap: 1.25rem;

  /* Typography / Visuals */
  font-size: 12px;
}

.down-buttons {
  display: grid;
  grid-template-columns: max-content max-content;
  column-gap: 3rem;
}

.buttons button {
  /* Box Model */
  padding: 0.25rem 1rem;
  width: 11.25rem;
  min-width: max-content;
  border-radius: 0.1875rem;

  /* Typography / Visuals */
  color: var(--text-primary);
  letter-spacing: 0.0625rem;
  text-align: center;
}

.buttons button:hover {
  /* Typography / Visuals */
  color: var(--text-light);

  /* Miscellaneous / Interactions */
  background-position: right center;
}

.buttons button:active {
  box-shadow: none;
}

/* Utilities */

.glow-animation {
  /* Box Model */
  border: 1px solid var(--border-dark);

  /* Typography / Visuals */
  background-image: linear-gradient(
    to right,
    var(--gradient-shine) 0%,
    var(--gradient-bright) 51%,
    var(--gradient-shine) 100%
  );

  /* Miscellaneous / Interactions */
  transition: 0.5s;
  background-size: 200% auto;
  box-shadow:
    inset 0 1px 0 var(--rgba-white-heavy),
    inset 0 -1px 0 var(--rgba-black-heavy),
    0 2px 4px var(--rgba-black-heavy);
}

@media (max-width: 850px) {
  .boards-container {
    flex-direction: column;
    gap: 1.25rem;
  }
}

@media (max-width: 550px) {
  .logo-text {
    /* Box Model */
    margin: 0.375rem; /* 0.625 × 0.6 */

    /* Typography / Visuals */
    font-size: 3rem;
    letter-spacing: 0.075rem; /* 0.125 × 0.6 */

    /* Miscellaneous / Interactions */
    text-shadow:
      0 -0.6px 0 var(--shadow-1),
      0 0.6px 0 var(--shadow-2),
      0 1.2px 0 var(--shadow-3),
      0 1.8px 0 var(--shadow-4),
      0 2.4px 0 var(--shadow-5),
      0 3px 0 var(--shadow-6),
      0 3.6px 0 var(--shadow-7),
      0 4.2px 0 var(--shadow-8),
      0 4.8px 0 var(--shadow-9),
      0 5.4px 0 var(--shadow-10),
      0 6px 0 var(--shadow-11),
      0 6.6px 0 var(--shadow-12),
      0 7.2px 0 var(--shadow-13),
      0 7.8px 0 var(--shadow-14),
      0 8.4px 0 var(--shadow-15),
      0 9px 0 var(--shadow-16),
      0 0.825rem 1.125rem var(--rgba-black-darkest); /* 1.375 × 0.6, 1.875 × 0.6 */
  }

  .outter-board-wrap {
    padding: 8px;
  }

  .inner-board-wrap {
    padding: 2px;
  }

  .human-board,
  .cpu-board {
    width: 80vw;
    height: 80vw;
  }

  .buttons button {
    width: 10rem;
  }

  .buttons {
    row-gap: 1rem;
  }

  .down-buttons {
    grid-template-columns: max-content;
    row-gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,+BAA+B;AACjC;;AAEA,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA,sBAAsB;;AAEtB;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,uBAAuB;;EAEvB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;;EAEpB,2BAA2B;EAC3B,+BAA+B;EAC/B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;;EAEjB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;;EAEzB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,wBAAwB;EACxB,4CAA4C;EAC5C,6CAA6C;EAC7C,+CAA+C;EAC/C,uCAAuC;EACvC,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB;;;;;GAKC;AACH;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mEAAmE;EACnE,gBAAgB;;EAEhB,cAAc;EACd,oBAAoB;;EAEpB,yBAAyB;EACzB,4DAA4D;EAC5D,gBAAgB;;EAEhB,mCAAmC;;EAEnC,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA,gBAAgB;;AAEhB;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4CAAgD;AAClD;;AAEA,sBAAsB;;AAEtB;EACE,cAAc;EACd,gBAAgB;;EAEhB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;;EAEvB,iCAAiC;EACjC;;;;;;;;;;;;;;;;;iDAiB+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,oCAAoC;;EAEpC,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB;;;;;;;;;;;;KAYG;;EAEH,iCAAiC;EACjC;;;qCAGmC;AACrC;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;;EAE3B,yBAAyB;EACzB;;;;GAIC;AACH;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;;EAEtB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;;EAEhB,yBAAyB;EACzB;;;;GAIC;AACH;;AAEA;EACE,YAAY;EACZ;;;;GAIC;AACH;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;;EAEb,cAAc;EACd,YAAY;EACZ,aAAa;;EAEb,iBAAiB;EACjB,yBAAyB,EAAE,WAAW;EACtC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA,UAAU;;AAEV;EACE,uBAAuB;EACvB,aAAa;EACb,OAAO;;EAEP,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,4CAA4C;;EAE5C,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;;EAEV,iCAAiC;EACjC,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,YAAY;;AAEZ;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;;EAEhB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,wBAAwB;;EAExB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;;EAExB,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;;AAEd;EACE,cAAc;EACd,oCAAoC;;EAEpC,yBAAyB;EACzB;;;;;GAKC;;EAED,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B;;;qCAGmC;AACrC;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB,EAAE,gBAAgB;;IAElC,yBAAyB;IACzB,eAAe;IACf,wBAAwB,EAAE,gBAAgB;;IAE1C,iCAAiC;IACjC;;;;;;;;;;;;;;;;;mDAiB+C,EAAE,6BAA6B;EAChF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kCAAkC;IAClC,aAAa;EACf;AACF","sourcesContent":["/* CSS Modern Reset */\n\n* {\n  /* outline: 3px solid orange; */\n}\n\n/* 1. Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* 2. Remove default margin */\n* {\n  margin: 0;\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* Typography / Visuals */\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* 6. Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* 7. Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\n/* 9. Improve line wrapping */\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\n/* Custom Properties */\n\n:root {\n  /* Primary Colors */\n  --bg-primary: hsl(0, 1%, 33%);\n  --bg-dark-light: #4a4a4a;\n  --bg-dark-medium: #3b3b3b;\n  --bg-dark-heavy: #2e2e2e;\n  --bg-board: rgba(14, 32, 65);\n  --bg-sunk-ship: #480c0c;\n\n  /* Text Colors */\n  --text-primary: #e6e6e6;\n  --text-light: #fff;\n  --text-logo: #6b6a6a;\n\n  /* Border & Accent Colors */\n  --border-light: hsl(0, 0%, 68%);\n  --border-dark: #1f1f1f;\n  --accent-blue-1: #00d2ff;\n  --accent-blue-2: #3a47d5;\n  --accent-purple: purple;\n  --accent-red: red;\n\n  /* Gradient Colors */\n  --gradient-shine: #232526;\n  --gradient-bright: #414345;\n  --gradient-accent-1: #777;\n  --gradient-accent-2: #222;\n\n  /* Logo Shadow Colors */\n  --shadow-1: #fff;\n  --shadow-2: #2e2e2e;\n  --shadow-3: #2c2c2c;\n  --shadow-4: #2a2a2a;\n  --shadow-5: #282828;\n  --shadow-6: #262626;\n  --shadow-7: #242424;\n  --shadow-8: #222;\n  --shadow-9: #202020;\n  --shadow-10: #1e1e1e;\n  --shadow-11: #1c1c1c;\n  --shadow-12: #1a1a1a;\n  --shadow-13: #181818;\n  --shadow-14: #161616;\n  --shadow-15: #141414;\n  --shadow-16: #121212;\n\n  /* Transparency Colors */\n  --rgba-white-heavy: rgba(255, 255, 255, 0.2);\n  --rgba-white-light: rgba(255, 255, 255, 0.18);\n  --rgba-white-lighter: rgba(255, 255, 255, 0.08);\n  --rgba-black-medium: rgba(0, 0, 0, 0.2);\n  --rgba-black-heavy: rgba(0, 0, 0, 0.6);\n  --rgba-black-darkest: rgba(0, 0, 0, 0.9);\n}\n\nhtml {\n  height: 100%;\n}\n\nhtml,\nbody {\n  min-height: 100%;\n  background: radial-gradient(\n    circle at center,\n    #3f3f3f 0%,\n    #2f2f2f 40%,\n    #1e1e1e 100%\n  );\n}\n\nbody {\n  /* Grid / Flex Layout */\n  display: grid;\n  place-items: center;\n  grid-template-rows: max-content max-content max-content max-content;\n  row-gap: 1.75rem;\n\n  /* Box Model */\n  padding-bottom: 28px;\n\n  /* Typography / Visuals */\n  font-family: 'Progress', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.5;\n\n  -webkit-font-smoothing: antialiased;\n\n  /* Miscellaneous / Interactions */\n  box-shadow: inset 0 0 7.5rem rgba(0, 0, 0, 0.4);\n}\n\n/* Text / Font */\n\np {\n  color: var(--text-primary);\n  font-size: 1.25rem;\n}\n\n@font-face {\n  font-family: Progress;\n  src: url(/src/fonts/PROGRESS\\ PERSONAL\\ USE.ttf);\n}\n\n/* Logo / Info Panel */\n\n.logo-text {\n  /* Box Model */\n  margin: 0.625rem;\n\n  /* Typography / Visuals */\n  font-size: 5rem;\n  font-weight: 500;\n  letter-spacing: 0.125rem;\n  color: var(--text-logo);\n\n  /* Miscellaneous / Interactions */\n  text-shadow:\n    0 -1px 0 var(--shadow-1),\n    0 1px 0 var(--shadow-2),\n    0 2px 0 var(--shadow-3),\n    0 3px 0 var(--shadow-4),\n    0 4px 0 var(--shadow-5),\n    0 5px 0 var(--shadow-6),\n    0 6px 0 var(--shadow-7),\n    0 7px 0 var(--shadow-8),\n    0 8px 0 var(--shadow-9),\n    0 9px 0 var(--shadow-10),\n    0 10px 0 var(--shadow-11),\n    0 11px 0 var(--shadow-12),\n    0 12px 0 var(--shadow-13),\n    0 13px 0 var(--shadow-14),\n    0 14px 0 var(--shadow-15),\n    0 15px 0 var(--shadow-16),\n    0 1.375rem 1.875rem var(--rgba-black-darkest);\n}\n\n.info-container {\n  /* Box Model */\n  position: relative;\n  min-width: 28%;\n  padding: 0.5rem 2rem;\n  border-radius: 0.1875rem;\n  border: 1px solid var(--border-dark);\n\n  /* Typography / Visuals */\n  text-align: center;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n  letter-spacing: 0.0625rem;\n  background:\n    radial-gradient(\n      ellipse at center,\n      var(--rgba-white-light) 0%,\n      var(--rgba-white-lighter) 40%,\n      var(--rgba-black-medium) 100%\n    ),\n    linear-gradient(\n      to bottom,\n      var(--bg-dark-light) 0%,\n      var(--bg-dark-medium) 50%,\n      var(--bg-dark-heavy) 100%\n    );\n\n  /* Miscellaneous / Interactions */\n  box-shadow:\n    inset 0 1px 0 var(--rgba-white-heavy),\n    inset 0 -1px 0 var(--rgba-black-heavy),\n    0 2px 4px var(--rgba-black-heavy);\n}\n\n.info-container::before,\n.info-container::after {\n  /* Box Model */\n  content: '';\n  position: absolute;\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  top: 50%;\n  transform: translateY(-50%);\n\n  /* Typography / Visuals */\n  background: radial-gradient(\n    circle,\n    var(--gradient-accent-1) 0%,\n    var(--gradient-accent-2) 70%\n  );\n}\n\n.info-container::before {\n  left: 0.75rem;\n}\n\n.info-container::after {\n  right: 0.75rem;\n}\n\n/* Game Boards */\n\n.boards-container {\n  display: flex;\n  gap: 3rem;\n}\n\n.outter-board-wrap {\n  /* Box Model */\n  position: relative;\n  padding: 0.5625rem;\n  border-radius: 0.25rem;\n\n  /* Miscellaneous / Interactions */\n  transition: background-position 0.3s ease;\n}\n\n.outter-board-wrap:hover {\n  background-position: center right;\n}\n\n.inner-board-wrap {\n  /* Box Model */\n  position: relative;\n  padding: 0.25rem;\n\n  /* Typography / Visuals */\n  background: linear-gradient(\n    to right,\n    var(--accent-blue-1) 0%,\n    var(--accent-blue-2) 60%\n  );\n}\n\n.inner-board-wrap.enemy {\n  /* Visuals */\n  background: linear-gradient(\n    to right,\n    var(--accent-purple),\n    var(--accent-red)\n  );\n}\n\n.human-section,\n.cpu-section {\n  display: grid;\n  place-items: center;\n  row-gap: 0.75rem;\n}\n\n.human-board,\n.cpu-board {\n  display: grid;\n\n  /* Box Model */\n  width: 348px;\n  height: 348px;\n\n  user-select: none;\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n}\n\n/* Cells */\n\n.cell {\n  /* Grid / Flex Layout */\n  display: flex;\n  flex: 1;\n\n  /* Box Model */\n  position: relative;\n  border-right: 2px solid var(--border-light);\n  border-bottom: 2px solid var(--border-light);\n\n  /* Typography / Visuals */\n  background-color: var(--bg-board);\n}\n\n.row .cell:nth-child(10) {\n  border-right: 0px;\n}\n\n.row:nth-child(10) .cell {\n  border-bottom: 0px;\n}\n\n.cpu-board .cell:hover {\n  cursor: crosshair;\n}\n\n.human-board .cell:hover {\n  cursor: not-allowed;\n}\n\n.cell > img {\n  /* Box Model */\n  position: absolute;\n  width: 60%;\n\n  /* Miscellaneous / Interactions */\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.cell.ship:not(.sunk) {\n  background-image: linear-gradient(\n    to right,\n    var(--gradient-shine) 0%,\n    var(--gradient-bright) 51%,\n    var(--gradient-shine) 100%\n  );\n  background-size: 200% auto;\n}\n\n.cell.ship.sunk {\n  background-color: var(--bg-sunk-ship);\n}\n\n/* Buttons */\n\n.buttons {\n  /* Grid / Flex Layout */\n  display: grid;\n  place-items: center;\n  grid-template-rows: max-content max-content;\n  row-gap: 1.25rem;\n\n  /* Typography / Visuals */\n  font-size: 12px;\n}\n\n.down-buttons {\n  display: grid;\n  grid-template-columns: max-content max-content;\n  column-gap: 3rem;\n}\n\n.buttons button {\n  /* Box Model */\n  padding: 0.25rem 1rem;\n  width: 11.25rem;\n  min-width: max-content;\n  border-radius: 0.1875rem;\n\n  /* Typography / Visuals */\n  color: var(--text-primary);\n  letter-spacing: 0.0625rem;\n  text-align: center;\n}\n\n.buttons button:hover {\n  /* Typography / Visuals */\n  color: var(--text-light);\n\n  /* Miscellaneous / Interactions */\n  background-position: right center;\n}\n\n.buttons button:active {\n  box-shadow: none;\n}\n\n/* Utilities */\n\n.glow-animation {\n  /* Box Model */\n  border: 1px solid var(--border-dark);\n\n  /* Typography / Visuals */\n  background-image: linear-gradient(\n    to right,\n    var(--gradient-shine) 0%,\n    var(--gradient-bright) 51%,\n    var(--gradient-shine) 100%\n  );\n\n  /* Miscellaneous / Interactions */\n  transition: 0.5s;\n  background-size: 200% auto;\n  box-shadow:\n    inset 0 1px 0 var(--rgba-white-heavy),\n    inset 0 -1px 0 var(--rgba-black-heavy),\n    0 2px 4px var(--rgba-black-heavy);\n}\n\n@media (max-width: 850px) {\n  .boards-container {\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n}\n\n@media (max-width: 550px) {\n  .logo-text {\n    /* Box Model */\n    margin: 0.375rem; /* 0.625 × 0.6 */\n\n    /* Typography / Visuals */\n    font-size: 3rem;\n    letter-spacing: 0.075rem; /* 0.125 × 0.6 */\n\n    /* Miscellaneous / Interactions */\n    text-shadow:\n      0 -0.6px 0 var(--shadow-1),\n      0 0.6px 0 var(--shadow-2),\n      0 1.2px 0 var(--shadow-3),\n      0 1.8px 0 var(--shadow-4),\n      0 2.4px 0 var(--shadow-5),\n      0 3px 0 var(--shadow-6),\n      0 3.6px 0 var(--shadow-7),\n      0 4.2px 0 var(--shadow-8),\n      0 4.8px 0 var(--shadow-9),\n      0 5.4px 0 var(--shadow-10),\n      0 6px 0 var(--shadow-11),\n      0 6.6px 0 var(--shadow-12),\n      0 7.2px 0 var(--shadow-13),\n      0 7.8px 0 var(--shadow-14),\n      0 8.4px 0 var(--shadow-15),\n      0 9px 0 var(--shadow-16),\n      0 0.825rem 1.125rem var(--rgba-black-darkest); /* 1.375 × 0.6, 1.875 × 0.6 */\n  }\n\n  .outter-board-wrap {\n    padding: 8px;\n  }\n\n  .inner-board-wrap {\n    padding: 2px;\n  }\n\n  .human-board,\n  .cpu-board {\n    width: 80vw;\n    height: 80vw;\n  }\n\n  .buttons button {\n    width: 10rem;\n  }\n\n  .buttons {\n    row-gap: 1rem;\n  }\n\n  .down-buttons {\n    grid-template-columns: max-content;\n    row-gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
